import * as React from "react";
import { CircleCheckBig } from "lucide-react";
import { AttachmentChip } from "../../shared/components/AttachmentChip";

interface SelectedTaskContextChipProps {
  name: string | null;
  onClear: () => void;
  disabled?: boolean;
}

export const SelectedTaskContextChip: React.FC<SelectedTaskContextChipProps> = ({
  name,
  onClear,
  disabled = false,
}) => {
  if (!name) return null;

  return (
    <AttachmentChip
      icon={<CircleCheckBig />}
      label={name}
      onRemove={onClear}
      disabled={disabled}
      ariaLabel="Attached task"
    />
  );
};
